import { getListFromFormData } from "utils/formSelectMultiple";
import { normalizeAOIBAN } from "utils/const";

export function colectiveRegistrationMap(formData) {
  if (formData != null && formData !== undefined) {
    const userColectiveTypeId = formData.userColectiveTypeId?.code ?? formData.userColectiveTypeId ?? null;
    const companyPropertyTypeId = formData.companyPropertyTypeId?.code ?? formData.companyPropertyTypeId ?? null;
    const isCooperative = Number(userColectiveTypeId) === 2;
    const registrationEmail = formData.email || formData.companyEmail || "";
    
    return {
      user: {
        id: "",
        userType: 2,
        name: formData.name ? formData.name : "",
        mobilePhone: formData.mobilePhone ? formData.mobilePhone : "",
        alternativeMobilePhone: formData.alternativeMobilePhone ? formData.alternativeMobilePhone : "",
        email: registrationEmail,
        password: formData.password ? formData.password : "",
        userCode: "",
        userColective: {
          userColectiveTypeId,
          contactName: formData.contactName ? formData.contactName : "",
          businessPurposeList: getListFromFormData(formData.businessPurpose) ?? [],
          taxIdNumber: formData.taxIdNumber ? formData.taxIdNumber : "",
          permitCode: formData.permitCode ? formData.permitCode : "",
          permitCodeValidUntil: formData.permitCodeValidUntil ? formData.permitCodeValidUntil : null,
          niss: formData.niss ? formData.niss : "",
          experience: !isCooperative && formData.experience ? formData.experience : null,
          companyEmail: formData.companyEmail ? formData.companyEmail : "",
          companyPhone: formData.companyPhone ? formData.companyPhone : "",
          compositeAddress: {
            provinceId: formData.province ? formData.province.code : null,
            provinceKey: formData.province ? formData.province.keyValue : "",
            municipalityId: formData.municipality ? formData.municipality.code : null,
            district: formData.district ? formData.district : "",
            address: formData.address ? formData.address : "",
          },
          companyEACId: formData.companyEACId ? formData.companyEACId.code : null,
          propertyType: formData.propertyType ?? "",
          IsStartupOrMicroenterprise: !isCooperative ? Boolean(formData.IsStartupOrMicroenterprise) : false,
          subsidiaryCompany: !isCooperative ? (formData.subsidiaryCompany ?? "") : "",
          subsidiaryCompanyPostalCode: !isCooperative ? (formData.subsidiaryCompanyPostalCode ?? "") : "",
          subsidiaryCompanyActivity: !isCooperative ? (formData.subsidiaryCompanyActivity ?? "") : "",
          subsidiaryCompanyEACId: !isCooperative ? (formData.subsidiaryCompanyEACId?.code ?? null) : null,
          maleWorkersNumber: formData.maleWorkersNumber ?? null,
          femaleWorkersNumber: formData.femaleWorkersNumber ?? null,
          companyPropertyTypeId: !isCooperative ? companyPropertyTypeId : null,
          bankAccountNumber: isCooperative ? normalizeAOIBAN(formData.bankAccountNumber ?? "") : "",
          disableWorkersNumber: isCooperative ? (formData.disableWorkersNumber ?? null) : null,
        },
      },
    };
  }
  return formData;
}

export default colectiveRegistrationMap;
